import axios from 'axios'
import Cookies from 'js-cookie'
import $ from 'jquery'
import {Message} from 'element-ui'


const pdAxios = axios.create()
const baseUrl = window.OauthConfig.pdBase + '/kgapi'
const isDev = process.env.NODE_ENV === 'development'
let allToken = ''
let service = ''

function queryURLParams (url) {
  let obj = {}
  url.replace(/([^?=&#]+)=([^?=&#]+)/g, (_, key, value) => obj[key] = value)
  return obj
}

// 用户验证接口
function getmembername () {
  let str = location.href
  let num = str.indexOf('#')
  str = str.substr(num + 1)
  const windowUrl = window.location.origin + '/login#' + str
  let url = '/api/pc/getmembername'
  // if (isDev) {
  //   url = 'http://192.168.1.10:9899' + url
  // } else {
    url = window.location.origin + url
  // }
  $.ajax({
    type: 'POST',
    async: false, // fasle表示同步请求，true表示异步请求
    xhrFields: {
      withCredentials: true
    },
    url, // 请求地址
    success: function (result) { // 请求成功
      if (!result.state) {
        window.location.href = windowUrl
      } else {
        service = result.data.token[0]
      }
    },
    error: function (e) {
      window.location.href = windowUrl
    }
  })
}

// 获取token
function getToken () {
  const useId = Cookies.get('imsilkroad_userid')
  const useName = Cookies.get('imsilkroad_username')
  if (useId && useName) {
    if (Cookies.get('imsilkroad_kgtoken')) {
      let cookieService = Cookies.get('imsilkroad_kgtoken')
      cookieService = window.atob(cookieService)
      const lastIndex = cookieService.lastIndexOf('(')
      service = cookieService.slice(0, lastIndex)
    } else {
      const query = queryURLParams(window.location.href)
      service = sessionStorage.getItem('imsilkroad_kgtoken') || query.token || ''
      if (!service) {
        getmembername()
      }
    }
  } else {
    // 进行用户验证
    getmembername()
  }
  let _token = `${service}:${useId}:${useName}`
  _token = window.btoa(_token)
  // let baseUrl = 'http://192.168.1.10:8080/wq/kgapi'
  const url = `${baseUrl}/auth/getToken`
  $.ajax({
    type: 'POST',
    async: false, // fasle表示同步请求，true表示异步请求
    xhrFields: {
      withCredentials: true
    },
    contentType: 'application/json;charset=UTF-8',
    url, // 请求地址
    data: JSON.stringify({token: _token}), // 数据，json字符串
    success: function (result) { // 请求成功
      if (result.errCode === 200) {
        let _data = result.data
        allToken = _data
        window.allToken = _data
        creastTimeToken()
      }
    },
    error: function (e) {
    }
  })
}

// 设置携带Cookie信息
pdAxios.defaults.withCredentials = false
pdAxios.interceptors.request.use(config => {
  if (config.baseURL && config.baseURL.indexOf('/kgapi') !== -1 && config.url !== '/auth/getToken') {
    if (!allToken && !window.allToken) {
      getToken()
      console.log(allToken)
    }
    config.headers['API-TOKEN'] = allToken
  }
  return config
}, (error) => {
  return Promise.reject(error)
})
// 状态码

pdAxios.interceptors.response.use(
  response => {
    return response
  },
  // 服务器状态码不是200的情况
  error => {
    return Promise.reject(error)
  })

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get (url, params) {
  // object
  if (typeof params == 'object') {
    params['brandToken'] = localStorage.getItem('brand-token')
  }
  //  undefind
  else if (typeof params == 'undefined') {
    params = {
      brandToken: localStorage.getItem('brand-token')
    }
  }
  return new Promise((resolve, reject) => {
    pdAxios
      .get(url, {
        params: params
      })
      .then((res) => {
        // console.log(res,'logo')
        // console.log(res,'RES')
        resolve(res.data)
      })
      .catch((err) => {
        Message.error({
          message: `Connection to server failed !`,
          duration: 3000
        })
      })
  })
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]。
 * @param {Object} params [请求时携带的参数]
 */
export function post (url, params, Content = 'application/json') {
  return new Promise((resolve, reject) => {
    pdAxios
      .post(url, params, {
        headers: {
          'Content-Type': Content
          // 'Accept': '*/*'
        }
      })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        // Message.error({
        //   message: `连接服务器失败,请刷新后重试!`,
        //   duration: 3000
        // });
        reject(err)
      })
      .finally(() => {
        setTimeout(() => {
          // store.commit('changeLoadingstate', false);
        }, 500)
      })
  })
}

function creastTimeToken () {
  window.pdTokenINterval && clearTimeout(window.pdTokenINterval)
  window.pdTokenINterval = setTimeout(() => {
    allToken = ''
    window.allToken = ''
  }, 270000)
}

export {pdAxios, getToken}
